import { render, staticRenderFns } from "./DropdownClients.vue?vue&type=template&id=52040358&scoped=true"
import script from "./DropdownClients.vue?vue&type=script&lang=js"
export * from "./DropdownClients.vue?vue&type=script&lang=js"
import style0 from "./DropdownClients.vue?vue&type=style&index=0&id=52040358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52040358",
  null
  
)

export default component.exports